
import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.btn = this.el.querySelector('.menuBtn')
    this.main = this.el.querySelector('.menuMain')
    this.inner = this.el.querySelector('.menuInner')
    this.items = this.el.querySelectorAll('.menu-item')

    this.setVaribles()
    this.initEventListeners()
  }
  
  initEventListeners() {

    this.btn.addEventListener('click', () => {
      this.setVaribles()
      this.isOpen?  this.closeMenu() : this.openMenu()
    })

    window.addEventListener('resize', () => this.setVaribles())
  }

  setVaribles() {
    this.isMobile = window.innerWidth < 900

    const menuWidth = this.inner.offsetWidth 
    document.documentElement.style.setProperty('--menu-width', `${menuWidth}px`);

    const menuHeight = window.innerHeight - 32 - (this.el.offsetHeight - this.main.offsetHeight) // 16px top margin + 16px bottom margin
    document.documentElement.style.setProperty('--menu-height', `${menuHeight}px`);

    const headerHeight = this.isMobile ?
    (this.el.offsetHeight - this.main.offsetHeight) + 32
    : this.el.offsetHeight + 40
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }

  openMenu() {
    this.el.classList.add('--open')
    this.main.classList.add('--open')

    gsap.to(this.items, { opacity: 1, duration: 0.5, stagger: 0.1, ease: 'power2.inOut' })

    this.isOpen = true
  }

  closeMenu() {
    this.el.classList.remove('--open')
    this.main.classList.remove('--open')

    gsap.to(this.items, { opacity: 0, duration: 0.5, stagger: -0.1, ease: 'power2.inOut' })

    this.isOpen = false
  }


}
